import React from 'react';
import { Outlet } from 'react-router-dom';

function MerchantContainer() {
    return <Outlet />;
}

export default MerchantContainer;
